import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TBar, TBarParams } from './cp-bar';

@Component({
    selector: 'cp-barschart',
    templateUrl: './cp-barschart.component.html',
    styleUrls: ['./cp-barschart.component.css'],
    standalone: false
})
export class CpBarschartComponent implements OnChanges {

  @Input() params: TBarParams[] = [];
  bars: TBar[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.params) {
      this.bars = [];
      if (typeof (this.params) !== 'undefined') {

        let baseBarWidth = 18;
        let baseBarX = 0;
        let baseTextX = 0;

        const controlIncrement: number = this.GetStartIncrement(this.params.length);
        baseBarX = controlIncrement;
        baseTextX = controlIncrement + 9;
        let index = 0;

        this.params.forEach(
          itm => {
            if(index <= 4){
              const tbar = new TBar();
              const percbase = 85 * itm.percent / 100;
              const percY = 90 - percbase;

              tbar.topText = itm.percent.toLocaleString(navigator.language) + '%';
              tbar.topX = baseTextX.toString() + '%';
              tbar.topY = (percY - 2).toString() + '%';

              tbar.barX = baseBarX.toString() + '%';
              tbar.barY = percY.toString() + '%';
              tbar.barHeigth = percbase.toString() + '%';
              tbar.barWidth = baseBarWidth.toString() + '%';

              tbar.bottomText = itm.text;
              tbar.bottomX = baseTextX.toString() + '%';
              tbar.bottomY = '95%';

              this.bars.push(tbar);
              baseBarX += baseBarWidth + 3;
              baseTextX = baseBarX + 9;
              index++;
            }
          }
        );
      }
    }
  }

  GetStartIncrement(numberItens: number): number {
    if(numberItens == 4)
      return 9;
    else if(numberItens == 3)
      return 20;
    else if(numberItens == 2)
      return 30;
    else
      return 40;
  }
}
